import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import ConfigView from 'components/configuration/config-view';

import fetchExternalData from 'utils/fetch-external-data';
import { getLocationParam, getLocationParamBoolean } from 'utils/get-query-param';
import { getNextConfigVersion } from 'utils/project-definition/project-definition-data-access';

const DEFAULT_BACKGROUND_COLOR = '#FFFFFF';

const ERROR_NO_PRODUCT_OR_SYSTEM = { id: 'NO_PRODUCT_OR_SYSTEM', message: 'No productId or systemId found in query params' };

export default class SystemView extends Component {

  /* Lifecycle */

  constructor(props) {
    super(props);

    this.state = {
      config: null,
      configProducts: null,
      errors: [],
      loading: false,
      originalSystem: null,
    };

    this.configLoadedHandler = this.configLoadedHandler.bind(this);
  }

  componentWillMount() {
    let { configVersion } = this.state;

    const projectID = this.getProjectID();
    const systemID = this.getSystemID();

    let endPoints = null;
    if (projectID) {
      endPoints = [
        `/api/projects/${projectID}/definition`,
        `/api/projects/${projectID}/system-products`,
        `/api/projects/${projectID}/original_system`,
      ];
    } else if (systemID) {
      endPoints = [
        `/api/systems/${systemID}/definition`,
        `/api/systems/${systemID}/system-products`,
        `/api/systems/${systemID}`,
      ];
    } else {
      this.addError(ERROR_NO_PRODUCT_OR_SYSTEM);
      return;
    }

    this.state.loading = true;
    fetchExternalData(endPoints).then((result) => {
      const config = result[0].json;
      const configProducts = result[1].json;
      const originalSystem = result[2].json;
      configVersion = getNextConfigVersion(configVersion);

      this.setState({
        config,
        configProducts,
        configVersion,
        loading: false,
        originalSystem,
      });
    });
  }

  /* Methods */

  addError(error, updateState = true) {
    if (!error) {
      return;
    }

    const { errors } = this.state;

    if (errors.indexOf(error) < 0) {
      errors.push(error);
      if (updateState) {
        this.setState({ errors });
      }
    }
  }

  configLoadedHandler() {
    document.dispatchEvent(new Event('remeha_system_view_loaded'));
  }

  // Make sure any value ends with a px if needed
  // Ignore values that end with %, px, em, rem, vw, ...
  formatCSSValue(value) {
    if (!value || value === 0 || value === '0') {
      return '0';
    }

    if (typeof (value) === 'number') {
      return `${Math.round(value)}px`;
    }

    const lastCharCode = value.charCodeAt(value.length - 1);

    // Check if value ends on a digit
    // -> add 'px'
    if (lastCharCode >= 48 && lastCharCode <= 57) {
      return `${value}px`;
    }

    return value;
  }

  getBackgroundColorParam() {
    const { location } = this.props;
    let backgroundColor = getLocationParam('background', null, location);

    if (backgroundColor === 'transparent') {
      return null;
    }

    if (!backgroundColor) {
      backgroundColor = DEFAULT_BACKGROUND_COLOR;
    }

    return backgroundColor;
  }

  // Note: Either use projectID or SystemID to render a system. ProjectID has priority
  getProjectID() {
    return getLocationParam('projectId', null, this.props.location);
  }

  getSystemID() {
    return getLocationParam('systemId', null, this.props.location);
  }

  removeError(error, updateState = true) {
    if (!error) {
      return;
    }

    const { errors } = this.state;
    const index = errors.indexOf(error);

    if (index >= 0) {
      errors.splice(index, 1);
      if (updateState) {
        this.setState({ errors });
      }
    }
  }

  /* Render */

  render() {
    const { location } = this.props;
    const {
      loading,
      config,
      configProducts,
      configVersion,
      errors,
      originalSystem,
    } = this.state;

    const projectID = this.getProjectID();

    if (errors && errors.length > 0) {
      const errorContent = errors.map((error) => {
        return (
          <div key={error.id}>
            ERROR: {error.message}
          </div>
        );
      });

      return (
        <div>
          {errorContent}
        </div>
      );
    }

    if (loading) {
      return (
        <div>
          <FormattedMessage id="systems.share.loading" /> {projectID}
        </div>
      );
    }

    const zoomable = getLocationParamBoolean('zoomable', false, location);
    const pannable = getLocationParamBoolean('pannable', false, location);
    const grid = getLocationParamBoolean('grid', false, location);
    const floor = getLocationParamBoolean('floor', false, location);
    const notes = getLocationParamBoolean('notes', false, location);
    let noteScale = getLocationParam(
      'noteScale',
      getLocationParam('notescale', null, location),
      location,
    );

    if (notes && typeof (noteScale) === 'string') {
      noteScale = parseFloat(noteScale);
    }

    const width = this.formatCSSValue(getLocationParam('width', '100%', location));
    const height = this.formatCSSValue(getLocationParam('height', '100%', location));
    const backgroundColor = this.getBackgroundColorParam();

    const viewStyle = {
      width,
      height,
    };

    return (
      <div id="small-system-view" style={viewStyle}>
        <ConfigView
          zoomable={zoomable}
          pannable={pannable}
          showGrid={grid}
          showFloor={floor}
          backgroundColor={backgroundColor}

          showNotes={notes}
          noteScale={noteScale}
          notesEditable={false}
          notesRemovable={false}

          zoom="contain"
          config={config}
          configProducts={configProducts}
          configVersion={configVersion}

          onLoaded={this.configLoadedHandler}

          originalSystem={originalSystem}
        />
      </div>
    );
  }
}

SystemView.propTypes = {
  location: PropTypes.object,
};



// WEBPACK FOOTER //
// ./js/views/system-view/index.jsx